import { MobileView } from '@modules/patient/ui/EhrPage/EhrHeaderContent/Center/views/MobileView';
import { DesktopView } from '@modules/patient/ui/EhrPage/EhrHeaderContent/Center/views/DesktopView';

export interface CenterParams {}

interface CenterContentProps extends CenterParams {
    fullName: string;
    birthDate: string;
    age: string;
    recordId: number;
    phone: string;
    isMobile: boolean;
}

export function Center(props: CenterContentProps) {
    return props.isMobile ? <MobileView /> : <DesktopView {...props} />;
}
